import { slugifyItalian } from '@/data/idGenerator';
import type { CalendarEntryType } from '../../types';

const makeSectionId = (label: string) => `sec_${slugifyItalian(label)}`;
const makeFieldId = (label: string) => `fld_${slugifyItalian(label)}`;
const makeFieldKey = (sectionLabel: string, fieldLabel: string) =>
  `${makeSectionId(sectionLabel)}.${makeFieldId(fieldLabel)}`;

export const NEXT_CALIBRATION_KEY = makeFieldKey(
  'Ispezione — frontespizio',
  'Prossima taratura sensori'
);
export const TRAINING_SCHEDULED_KEY = makeFieldKey(
  'Verifica aggiornamento formazione',
  'Prevista in data'
);
export const TRAINING_PARTICIPANTS_SECTION_ID = makeSectionId('Partecipanti corso');
export const TRAINING_PARTICIPANT_NAME_FIELD_ID = makeFieldId('Nome e cognome');

export const DATE_FORMATTER = new Intl.DateTimeFormat('it-IT', {
  day: '2-digit',
  month: '2-digit',
  year: 'numeric',
});

export const DAY_MS = 24 * 60 * 60 * 1000;

export const FREQUENCY_PATTERNS: Array<{ pattern: RegExp; months: number }> = [
  { pattern: /mensile/, months: 1 },
  { pattern: /bimestrale|ogni\s*2\s*mesi/, months: 2 },
  { pattern: /trimestrale|ogni\s*3\s*mesi/, months: 3 },
  { pattern: /quadrimestrale|ogni\s*4\s*mesi/, months: 4 },
  { pattern: /semestrale|ogni\s*6\s*mesi/, months: 6 },
  { pattern: /annuale|annual/, months: 12 },
  { pattern: /biennale|ogni\s*2\s*anni/, months: 24 },
];

export const TYPE_LABEL: Record<CalendarEntryType, string> = {
  inspection: 'Ispezione',
  report: 'Report',
  action: 'Azione',
  'non-conformity': 'Non conformità',
  training: 'Formazione',
  certification: 'Certificazione',
  calibration: 'Taratura',
};
